var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg022DriverBanned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 32",
    style: {
      enableBackground: "new 0 0 34 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#444444;}\r\n\t.st1{fill:#39B11F;stroke:#39B11F;stroke-linejoin:round;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32px_heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "banned-2-copy",
    transform: "translate(-164.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(24.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_2px_x5F_heart",
    transform: "translate(140.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-_x5B_14--1-7-18_x5D_",
    className: "st0",
    d: "M21.2,29.7c-2.8,0-5.3-1.3-6.9-3.4H3.8c-0.7,0-1.3-0.6-1.3-1.3 c0-5.3,4.3-9.7,9.6-9.7c0.7,0,1.3,0.1,2,0.2c1.6-2.2,4.2-3.6,7-3.6c4.8,0,8.8,4,8.8,8.8C30,25.7,26,29.7,21.2,29.7z  M21.2,14.6c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3S24.6,14.6,21.2,14.6z M12.2,12.9c-2.9,0-5.2-2.4-5.2-5.3 s2.3-5.3,5.2-5.3s5.2,2.4,5.2,5.3S15.1,12.9,12.2,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M22.7,20.6l6.9-6.9l1.8,1.8l-8.8,8.8L17.4,19l1.8-1.8L22.7,20.6z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg022DriverBanned);
export default __webpack_public_path__ + "static/media/022-driver-banned.77a007ef08abfa3c0f70f79d29c12787.svg";
export { ForwardRef as ReactComponent };